module.exports = __webpack_public_path__ + "img/3x.97b98b9.jpg";